import Sales from "./Sales/Sales.jsx";
import About from "./About/About.jsx";
import Brands from "./Brands/Brands.jsx";
import Contact from "./Contact/Contact.jsx";
import style from "./Home.module.css";

const Home = ({isMobile}) => {

    return(
        <div className={style.home}>
            <Sales isMobile={isMobile} />
            <div id="about"><About/></div>
            <div id="brands"><Brands/></div>
            <div id="contact"><Contact/></div>
            <div className={style.void}></div>
        </div>
    );
};

export default Home;